import { TemplateRef } from '@angular/core';
import { ObjectTools, SolActiveRouteStatus } from '@sol/components';

export class AppState {
  private constructor(
    public readonly showNavbar: boolean,
    public readonly activeRouteStatus: SolActiveRouteStatus,
    public readonly leadingBreadcrumbs: TemplateRef<void> | undefined,
  ) {}

  public static of(): AppState {
    return new AppState(true, 'loading', undefined);
  }

  public withLeadingBreadcrumbs(leadingBreadcrumbs: TemplateRef<void> | undefined): AppState {
    if (this.leadingBreadcrumbs === leadingBreadcrumbs) {
      return this;
    }
    return this.copy({ leadingBreadcrumbs });
  }

  public withShowNavbar(showNavbar: boolean): AppState {
    if (this.showNavbar === showNavbar) {
      return this;
    }
    return this.copy({ showNavbar });
  }

  public withActiveRouteStatus(activeRouteStatus: SolActiveRouteStatus): AppState {
    if (this.activeRouteStatus === activeRouteStatus) {
      return this;
    }
    return this.copy({ activeRouteStatus });
  }

  private copy(props: Partial<AppState>): AppState {
    return ObjectTools.copy<AppState>(this, props);
  }
}
